import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { IHeader } from '../../interfaces/header.interface';
import { LoaderService } from '../loader/loader.service';

/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase HeaderService, se usa para configurar el header en cada pantalla
 *
 * *HeaderService class definition, it's used to set up header in each screen*
 *
 * @type {class}
 */
export class HeaderService {
  /**
   * Instancia de subject como Subject<any>, observable de actualización de cambios
   *
   * *subject instance as Subject any>, updated changes observable*
   *
   * @access private
   * @type {Subject<any>} subject
   */
  private subject = new Subject<any>();
  private loaderService: LoaderService;
  /**
   * Declaración de headerState como suscriptor, escucha cambios
   *
   * *HeaderState declaration as Observable, listener of changes*
   *
   * @access private
   * @type {string} DEFAULT_URL_PATH
   */
  headerState = this.subject.asObservable();

  /**
   * Función para mostrar el header en las pantallas
   *
   * *Function to show the header on screens *
   *
   * @type {function}
   * @param {boolean} steps
   * @param {boolean} showTitle
   */
  show(steps?: boolean, showTitle?: boolean, close?: boolean) {
    const header: IHeader = { show: true, steps: !!steps, showTitle: !!showTitle, close: !!close };
    this.subject.next(header);
    // this.loaderService.hide()
  }

  /**
   * Función para ocultar el header en las pantallas
   *
   * *Function to hide the header on screens *
   *
   * @type {function}
   */
  hide() {
    const header: IHeader = { show: false, steps: false, showTitle: false, close: false };
    this.subject.next(header);
  }
}
